import type { RouteRecordRaw } from 'vue-router'
import { Layout } from '@/utils/routerHelper'

const adminGameRoutes: RouteRecordRaw[] = [
  {
    path: '/game',
    name: 'Game',
    component: Layout,
    meta: {
      title: '游戏管理',
      icon: 'mdi:gamepad-variant-outline',
      alwaysShow: true,
      hidden: true
    },
    children: [
      {
        path: 'list',
        name: 'GameList',
        component: () => import('@/views/Admin/Game/List.vue'),
        meta: {
          title: '游戏列表'
        }
      },
      {
        path: 'config',
        name: 'GameConfig',
        component: () => import('@/views/Admin/Game/Config.vue'),
        meta: {
          title: '游戏配置'
        }
      },
      {
        path: 'room',
        name: 'GameRoom',
        component: () => import('@/views/Admin/Game/Room.vue'),
        meta: {
          title: '房间配置'
        }
      },
      {
        path: 'server',
        name: 'GameServer',
        component: () => import('@/views/Admin/Game/Server.vue'),
        meta: {
          title: '服务器管理'
        }
      },
      {
        path: 'task',
        name: 'GameTask',
        component: () => import('@/views/Admin/Game/Task.vue'),
        meta: {
          title: '任务配置'
        }
      },
      {
        path: 'reward',
        name: 'GameReward',
        component: () => import('@/views/Admin/Game/Reward.vue'),
        meta: {
          title: '奖励配置'
        }
      },
      {
        path: 'reward-shard',
        name: 'GameRewardShard',
        component: () => import('@/views/Admin/Game/RewardShard.vue'),
        meta: {
          title: '奖励碎片'
        }
      },
      {
        path: 'exchange',
        name: 'GameExchange',
        component: () => import('@/views/Admin/Game/Exchange.vue'),
        meta: {
          title: '兑换记录'
        }
      },
      {
        path: 'battle',
        name: 'GameBattle',
        component: () => import('@/views/Admin/Game/Battle.vue'),
        meta: {
          title: '对战记录',
          hidden: true
        }
      }
    ]
  }
]

export default adminGameRoutes
